import { render, staticRenderFns } from "./SectionNews.vue?vue&type=template&id=cb34ecce&scoped=true"
import script from "./SectionNews.vue?vue&type=script&lang=ts"
export * from "./SectionNews.vue?vue&type=script&lang=ts"
import style0 from "./SectionNews.vue?vue&type=style&index=0&id=cb34ecce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb34ecce",
  null
  
)

export default component.exports